import Link from "next/link";

import Loader from "../../../../Atoms/Loader";

import React from "react";

import {
  AvailabilityStatus,
  Guide,
  Product,
  ProductAvailability,
  ProductAvailabilityGroup,
  ProductAvailabilityTime,
  useGetAvailableGuidesQuery,
} from "../../../../../graphql/operations";
import { addDuration, formatDate } from "../../../../../utils/calendarUtils";
import { useSession } from "../../../../Atoms/AppSession";

import styles from "./AvailableGuides.module.css";
import AvailableGuidesCarousel from "./AvailableGuidesCarousel";
interface Props {
  product: Omit<
    Product,
    | "translations"
    | "featuredGuide"
    | "reviews"
    | "price"
    | "prices"
    | "location"
    | "meetingPlaceGoogleMapsQuery"
    | "hasAccomodationVehiclePickup"
    | "hasDefaultVehiclePickup"
  >;
  bottom?: boolean;
}

export default function AvailableGuides({ product }: Props) {
  const session = useSession();

  const fromDate = React.useMemo<string>(() => formatDate(new Date()), []);
  const untilDate = React.useMemo<string>(
    () => formatDate(addDuration(new Date(), { weeks: 2 })),
    []
  );
  const { loading, error, data } = useGetAvailableGuidesQuery({
    ssr: false,
    variables: {
      productId: product.id,
      fromDate,
      untilDate,
      lang: session.languageCode,
    },
  });

  const productAvailability = data?.product.availability;

  let availableGuides = React.useMemo<
    {
      productAvailability: ProductAvailability;
      timeSlot: ProductAvailabilityTime;
      group: ProductAvailabilityGroup;
      guide?: Guide;
    }[]
  >(
    () =>
      productAvailability
        ? productAvailability
            .filter((pa) => pa.status === AvailabilityStatus.Available)
            .map((pa) =>
              pa.timeSlots
                .filter((t) => t.status === AvailabilityStatus.Available)
                .map((t) =>
                  t.groups.map((g) =>
                    g.guides.length > 0
                      ? g.guides.map((guide) => ({
                          productAvailability: pa,
                          timeSlot: t,
                          group: g,
                          guide: guide,
                        }))
                      : [
                          {
                            productAvailability: pa,
                            timeSlot: t,
                            group: g,
                            guide: undefined,
                          },
                        ]
                  )
                )
            )
            .flat()
            .flat()
            .flat()
        : [],
    [productAvailability]
  );

  // skip groups with no seats available
  // skip groups where there is no guide yet
  availableGuides = availableGuides.filter(
    (ag) => ag.group.seatsAvailable > 0 && ag.guide
  );

  if (loading) return <Loader />;
  if (error || !data || !productAvailability || !product) {
    return <>error</>;
  }

  if (availableGuides.length === 0) return <></>;

  return (
    <>
      <div className={styles.AvailableGuidesContainer}>
        <div className={styles.AvailableGuideList}>
          <AvailableGuidesCarousel
            title={"Assigned Guides for Upcoming Tours"}
            availableGuides={availableGuides}
            product={product}
          />
        </div>
        <Link
          href={`/checkout/${product.id}?ref=detail-guide-availability`}
          className="ui-Link"
          style={{ textAlign: "center", width: "100%", marginTop: 20 }}
        >
          SEE ALL AVAILABILITY
        </Link>
      </div>
    </>
  );
}
